import { useMemo, useState, useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import {SetMetaData} from './../../helper/page-title';
import ValidationHelper from "../../helper/validation";
import useInfiniteList from "../../hooks/infinite-list";
import useRowSelection from "../../hooks/row-selection";
import useColumnSettings from "../../hooks/column-setting";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import { error_api_call, post_api_call, get_api_call } from "../../actions/action-creators/common";
import { alertResponseMessage } from "../../actions/action-creators/response";
import { masterTableFieldsGrip,
        sessionOptions,
        programOptions,
        fieldValuesGrip,
        fieldUpdateGrip,
        fieldValidationGrip,
        fieldUpdateGripSA,
        fieldValidationGripSA
    } from "../../data/formData/glosco/sessions";
import FilterInput from "../../components/form/filter/filter-input";
import {SettingDropdownUi, TableCheckboxUi, RowDataUi} from "../../components/form/master-table/ui-static";
import MasterForm  from '../../components/form/master';
import normalizeFilters from "../../helper/filter/normalize-filter";

function GloscoGripSession(props) {
    SetMetaData("Manage GLOSCO-GRIP Sessions", "", "");
    const [filterData, setFilterData] = useState({});
    const [errorData, setErrorData] = useState({update_session: []});
    const [formYearData, setYearFormData] = useState({...fieldValuesGrip});
    const [isProcess, setIsProcess] = useState({update_session: false});
    const [refreshKey, setRefreshKey] = useState(0);

    const { columnSettings, updateColumn } = useColumnSettings({
        id: true,
        school_id: true,
        branch_id: true,
        glosco_session_count: true,
        grip_session_count: true
    });

    const [optionData, setOptionData] = useState({
        school_id: [],
        branch_id: [],
        glosco_session_count: sessionOptions,
        grip_session_count: sessionOptions,
    });

    // const memoizedFilterData = useMemo(
    //     () => filterData,
    //     [JSON.stringify(filterData)]
    // );
    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {
            school_id: "id",
            glosco_session_count: "id",
            grip_session_count: "id",
            branch_id: "id"
        }),
        [filterData]
    );

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["glosco_grip", refreshKey],
        apiCall: payload => post_api_call("schools-branches", payload),
                limit: 100,
                extraPayload: {
                    fetch_type: "glosco_grip",
                    filter: normalizedFilter
                }
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];
    // const visibleUserIds = masterTableData.map(r => r.id);

    const {
        // selectedIds,
        isChecked,
        isAllSelected,
        isIndeterminate,
        toggleRow,
        selectAllVisible,
        clearAllVisible
    } = useRowSelection({
        data: masterTableData,
        rowKey: "id",
        // value: formYearData.ref_ids_array || [],   // ✅ VERY IMPORTANT
        value: (formYearData.ref_ids_array || []).map(String),
        maxSelection: 300,
        onLimitExceed: limit => {
            alertResponseMessage({
                alert_type: 3,
                message: `You can select maximum ${limit} users at once.`
            });
        },
        onChange: ids => {
            setYearFormData(prev => ({
                ...prev,
                ref_ids_array: ids,
                ref_ids: ids.join(",")
            }));
        }
    });
    //Get Data from APIs
    const fetchSelectList = async(type, url) => {
      try{
          const selectApiData = await get_api_call(url, {});
          var data = [];
          if(selectApiData.status === 200){
              data = selectApiData.data;
              switch (type) {
                  case 'manage_glosco_session':
                    setOptionData({...optionData,
                        school_id: data?.schools,
                        branch_id: data?.branches,
                    });
                    break;
                  default: 
              }
          }
          return {
              data
          };
      }catch(e){
        error_api_call({error: `admin|screens|glosco|glosco-grip-session|fetchSelectList|${e}`});
        return {data: []};
      }
    }

    useEffect(() => {
        if(props.userRoleIds.includes(2)
            || props.userRoleIds.includes(7)
        ){
            fetchSelectList('manage_glosco_session', 'dropdown-options/manage-glosco-grip-session');
        }
    }, [props?.userRoleIds]);// eslint-disable-line react-hooks/exhaustive-deps

    const updateInput = (form_type, attrName, value) => {
        try {
            if(form_type === "update_session") {
                if(errorData[form_type].length){
                    setErrorData({...errorData, [form_type]: []});
                }
                
                if (attrName === "ref_ids") {
                    value = value
                        .replace(/[^0-9,]/g, "")   // allow digits & comma
                        .replace(/,{2,}/g, ",");   // prevent multiple commas

                    const ids = value
                        .split(",")
                        .map(v => v.trim())
                        .filter(Boolean)
                        .map(String);     // ✅ normalize

                    const uniqueIds = Array.from(new Set(ids));

                    setYearFormData(prev => ({
                        ...prev,
                        ref_ids: value,           // raw text
                        ref_ids_array: uniqueIds     // normalized
                    }));
                }else{
                    let fields = {...formYearData};
                    fields[attrName] = value;
                    setYearFormData({...fields});
                }
            }else if(form_type === "filter"){
                let fields = {...filterData};
                fields[attrName] = value;
                setFilterData({...fields});
            }
        } catch (e) {
            console.log(e);
            error_api_call({
                error: `admin|screens|glosco|glosco-grip-session|updateInput|${e}`
            });
        }
    };
    //Submit Details
    const submitForm = async(e, form_type='') => {
        try{
            e.preventDefault();
            setErrorData({...errorData, [form_type]: []});
            setIsProcess({...isProcess, [form_type]: true});
            var errorDetails = [];
            var apiFormData = new FormData();
            //Validation
            var validation = [];
            var inputData = {};
            var validationFields = {};
            switch (form_type) {
                case 'update_session':
                    inputData = {...formYearData};
                    validationFields = (props.userRoleIds.includes(2) || props.userRoleIds.includes(7))
                                        ? fieldValidationGripSA
                                        : fieldValidationGrip;
                    break;
                default:
            }
            validation = ValidationHelper.validation(inputData, validationFields).error;
            if(validation.length){
                errorDetails = validation;
            }
          
            if(errorDetails.length > 0){
                setErrorData({...errorData, [form_type]: errorDetails});
                setIsProcess({...isProcess, [form_type]: false});
                // setBtnDisabled({...isBtnDisabled, [form_type]: true});
            }else{
                //Send Data to Server
                var api = '';
                switch (form_type) {
                    case 'update_session':
                        api = 'glosco/update/glosco-grip-sessions';
                        apiFormData.append('session_id', inputData.session_id.id);

                        inputData.program_ids.forEach(program => {
                            apiFormData.append("program_ids[]", Number(program.id));
                        });

                        const uniqueIds = [...new Set(inputData.ref_ids_array)];
                        uniqueIds.forEach(id => {
                            if (id !== "" && id !== null) {
                                apiFormData.append("ref_ids[]", Number(id));
                            }
                        });
                        break;
                    default:
                }

                const updateOppor = await post_api_call(`${api}`, apiFormData);
                if(updateOppor.status === 200){
                    alertResponseMessage({alert_type: 1, message: "Information Updated Successfully"});
                    // setBtnDisabled({...isBtnDisabled, [form_type]: true});
                    clearAllVisible();
                    // setYearFormData({...formYearData, ref_ids: '', ref_ids_array: []});
                    setRefreshKey(prev => prev + 1); // 🔥 RESET TABLE
                }else{
                    if(typeof updateOppor.message !== "undefined"){
                        setErrorData({...errorData, [form_type]: [updateOppor.message]});
                    }
                }
                setIsProcess({...isProcess, [form_type]: false});
            }
          
        }catch(error){
            console.error(error);
            setErrorData({...errorData, [form_type]: ['Something Went Wrong, Please Try After Some Time']});
            setIsProcess({...isProcess, [form_type]: false});
            error_api_call({error: `admin|screens|glosco|glosco-grip-session|submitForm|${error}`});
        }
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card p-2 mb-2 mod-custom z-index-99999">
                    <Accordion
                        className="filter-custom"
                    >
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                Update Sessions
                            </Accordion.Header>
                            <Accordion.Body className="p-2">
                                <MasterForm
                                    formType={'update_session'}
                                    data={formYearData}
                                    _errorData={{...errorData}}
                                    _isProcess={{...isProcess}}
                                    // _isBtnDisabled={{...isBtnDisabled}}
                                    _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, field, value)}
                                    _submitForm={(e, form_type) => submitForm(e, form_type)}
                                    _formData={[{form_type: 'update_session',
                                                label: "Sessions",
                                                fields: (props.userRoleIds.includes(2) || props.userRoleIds.includes(7))
                                                        ? [...fieldUpdateGripSA]
                                                        : [...fieldUpdateGrip]}
                                            ]}
                                    selectOptions={{session_id:{
                                                        value: 'id',
                                                        label: 'session',
                                                        data: [...sessionOptions],
                                                    },
                                                    program_ids:{
                                                        value: 'id',
                                                        label: 'program',
                                                        data: [...programOptions],
                                                    }}
                                                }
                                />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>

            <InfiniteListWrapper
                dataLength={masterTableData.length}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
                isFetchingNextPage={isFetchingNextPage}
                emptyMessage="No Record found!"
            >
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        {/* SETTINGS */}
                        <SettingDropdownUi
                            checkedData={columnSettings}
                            fields={masterTableFieldsGrip}
                            updateColumn= {(field, value) => updateColumn(field, value)}
                        />

                        {/* TABLE */}
                        <div className="card-body table-responsive sticky-table pt-0 pe-0 ps-3">
                            <table className="table">
                                <thead>
                                <tr>
                                    <th>
                                        <TableCheckboxUi
                                            id="select_row"
                                            name="select_row"
                                            checked={isAllSelected}
                                            ref={el => el && (el.indeterminate = isIndeterminate)}
                                            // onChange={(e) =>
                                            //     e.target.checked ? selectAllVisible() : clearAllVisible()
                                            // }
                                            onChange={(e) => e.target.checked
                                                            ? selectAllVisible()
                                                            : clearAllVisible()}
                                        />
                                    </th>

                                    {masterTableFieldsGrip.map((col, i) => (
                                    (typeof col.accessRoleIds === "undefined" ||
                                        props.userRoleIds.some(role =>
                                        col.accessRoleIds.includes(role)
                                        )) &&
                                        columnSettings[col.field.name] && (
                                            <th key={i} className={`w-200p ${col.class_name || ""}`}>
                                            {col.title}
                                            {col.is_searchable && (
                                                <FilterInput
                                                    formType="filter"
                                                    field={col?.field}
                                                    data={filterData}
                                                    selectOptions={
                                                        (col.field?.type === "multi-select"
                                                        || col.field?.type === "select")
                                                        ?
                                                            {[col.field?.name]: {
                                                                value: col?.option_val,
                                                                label: col?.option_label,
                                                                data: optionData[col.field?.name]
                                                            }}
                                                        :
                                                            {}
                                                        }
                                                    _updateInput= {(form_type, data_type, input_type, field, value) => updateInput(form_type, field, value)}
                                                />
                                            )}
                                            </th>
                                        )
                                    ))}
                                    <th>Action</th>
                                </tr>
                                </thead>

                                <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="20" className="text-center p-4">
                                            <img
                                                alt="Loader"
                                                src={require("../../assets/images/Image-Loader.gif")}
                                            />
                                        </td>
                                    </tr>
                                ) : (
                                    masterTableData.length > 0 
                                    ? (
                                        masterTableData.map((row, index) => {
                                        return (
                                            <tr
                                                key={index}
                                                className={isChecked(row.id) ? "table-success" : ""}
                                                onClick={() => toggleRow(row.id)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <td onClick={e => e.stopPropagation()}>
                                                    <TableCheckboxUi
                                                        id={row.id}
                                                        name="select_row"
                                                        checked={isChecked(row.id)}
                                                        onChange={() => toggleRow(row.id)}
                                                    />
                                                </td>

                                                {masterTableFieldsGrip.map((tbl, i) => (
                                                    (typeof tbl.accessRoleIds === "undefined" ||
                                                    props.userRoleIds.some(role =>
                                                        tbl.accessRoleIds.includes(role)
                                                    )) &&
                                                    columnSettings[tbl.field.name] && (
                                                    <td key={i}>
                                                        {/* {row[tbl.fetch_key]} */}
                                                        <RowDataUi
                                                            fetch_key={tbl.fetch_key}
                                                            data={row}
                                                        />
                                                    </td>
                                                    )
                                                ))}

                                                <td onClick={e => e.stopPropagation()}>
                                                    {(row.branch_slug
                                                        && row.school_slug
                                                    ) && (
                                                        <a
                                                            href={`${process.env.REACT_APP_CLIENT_DOMAIN}/school/${row.school_slug}-${row.school_id}/${row.branch_slug}-${row.branch_id}`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                        View
                                                        </a>
                                                        )}
                                                </td>
                                            </tr>
                                        );
                                        })
                                    )
                                    : 
                                    <tr>
                                        {/* <td colSpan={props.userRoleIds.includes(2) ? 13 : 11}> */}
                                        <td colSpan="20">
                                        <div className="no-fellow text-center mt-4">
                                            {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                            <p className="pt-4 head">{"No Record Found!"}</p>
                                        </div>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </InfiniteListWrapper>
        </div>
    );
}

export default GloscoGripSession;